<template>
	<div class="rgb-sliders" v-if="rgb">
		<div class="rgb-slider rgb-slider--red stagger-in-up">
			<label class="rgb-slider__label">R</label>
			<slider class="rgb-slider__range" :value="red" :max="255" @input="updateField($event, 'red')"/>
			<input class="rgb-slider__number" 
				type="number" 
				min="0" 
				max="255" 
				:value="red" 
				@input="updateField($event, 'red')" 
				:disabled="disable">
		</div>
		<div class="rgb-slider rgb-slider--green stagger-in-up">
			<label class="rgb-slider__label">G</label>
			<slider class="rgb-slider__range" :value="green" :max="255" @input="updateField($event, 'green')"/>
			<input class="rgb-slider__number" 
				type="number" 
				min="0" 
				max="255" 
				:value="green" 
				@input="updateField($event, 'green')" 
				:disabled="disable">
		</div>
		<div class="rgb-slider rgb-slider--blue stagger-in-up">
			<label class="rgb-slider__label">B</label>
			<slider class="rgb-slider__range" :max="255" :value="blue" @input="updateField($event, 'blue')"/>
			<input class="rgb-slider__number" 
				type="number" 
				min="0" 
				max="255" 
				:value="blue" 
				@input="updateField($event, 'blue')" 
				:disabled="disable">
		</div>
	</div>
</template>

<script>
    import Color        from "../../../../../Lib/Color";
    import withinBounds from "../../../../../Lib/helpers/withinBounds";
    import BaseColorInput from "./BaseColorInput";
    import Slider         from "./Slider";

    export default {
        name: "RgbSliders",
        components: {Slider},
        extends: BaseColorInput,
        props: {
            disable: {
                default: false
            }
        },

        computed: {
            rgb() {
                return this.draft.rgb();
            },
            red() {
                return Math.round(this.rgb.red);
            },
            green() {
                return Math.round(this.rgb.green);
            },
            blue() {
                return Math.round(this.rgb.blue);
            },
        },

        data() {
            return {
                colorType: 'rgb',
            }
        },

        methods: {

            getValue() {
                return this.rgb;
            },

            getSanitizedColor(value) {
                value     = this.validateRGB(value);
                return Color.fromRGB(value);
            },

            validateRGB(value) {
                for(let property in value) {
                    value[property] = withinBounds(value[property], 0, 255);
                }

                return value;
            },
        }
    }
</script>